import script from "./ReminderComposerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderComposerPanel.vue?vue&type=script&setup=true&lang=js"

import "./ReminderComposerPanel.vue?vue&type=style&index=0&id=61d1c6ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d1c6ea"]])

export default __exports__